'use client';

import { TextOnlyButton } from '@/components/buttons/Buttons';
import type { ToastAction } from '@/types';
import styles from './toast.module.css';

interface Props {
	message: string;
	action?: ToastAction;
}

const NotificationToast = ({ message, action }: Props) => {
	return (
		<div className="flex justify-between items-center w-full">
			<div className={styles.message}>{message}</div>
			{action && (
				<TextOnlyButton
					id="notification-action"
					className={styles.action}
					onClick={action.handler}
				>
					{action.name}
				</TextOnlyButton>
			)}
		</div>
	);
};

export default NotificationToast;
